import React from 'react';
import axios from 'axios';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { ToastContainer, toast } from 'react-toastify';
import PhoneInput from 'react-phone-input-2';
import { isValidPhoneNumber } from 'libphonenumber-js';
import 'react-toastify/dist/ReactToastify.css';
import 'react-phone-input-2/lib/style.css';
import './Form.css';
import ClipLoader from 'react-spinners/ClipLoader';

const Form = ({formRef}) => {
    const formik = useFormik({
        initialValues: {
            name: '',
            email: '',
            number: '',
            message : '',
            countryCode: ''
        },
        validationSchema: Yup.object({
            name: Yup.string()
                .matches(/^[A-Za-z\s]+$/, 'Only letters and spaces are allowed')
                .required('Name is required'),

            email: Yup.string()
                .email('Invalid email')
                .required('Email is required'),
            number: Yup.string()
                .test('is-valid-phone', 'Invalid phone number', function (value) {
                    return isValidPhoneNumber(value || '');
                })
                .required('Phone is required'),
            message: Yup.string()
                .min(5, 'Message must be at least 5 characters')
                .optional(),

        }),
        onSubmit: async(values) => {
            try {
        const response = await axios.post(`${process.env.REACT_APP_API_URL}contact`, values );
        toast.success(response?.data?.message);
        console.log(values)
      
    } catch (error) {
        console.error('Error submitting data:', error);
       
    }
        },
    });

    return (
        <div ref={formRef} id="form" className="">
            <div className="form-container">
                <form className="formDiv" onSubmit={formik.handleSubmit}>
                    {/* <div className="formDiv-heading">
                        <h2>Get in Touch</h2>
                        <p>Need help or have questions? Our support team is ready to assist you.</p>
                    </div> */}
                    <div className="formDiv-body">
                        <input
                            name="name"
                            type="text"
                            placeholder="Name"
                            onChange={formik.handleChange}
                            value={formik.values.name}
                        />
                        {formik.touched.name && formik.errors.name && <div className="error">{formik.errors.name}</div>}

                        <input
                            name="email"
                            type="email"
                            placeholder="Email"
                            onChange={formik.handleChange}
                            value={formik.values.email}
                        />
                        {formik.touched.email && formik.errors.email && <div className="error">{formik.errors.email}</div>}

                        <PhoneInput
                            country={'in'}
                            value={formik.values.phone}
                            onChange={(phone, country) => {
                                 formik.setFieldValue('number', `+${phone}`)
                                 formik.setFieldValue('countryCode', country?.countryCode)
                            }} 
                            inputStyle={{ width: '100%' }}
                        />
                        {formik.touched.phone && formik.errors.phone && <div className="error">{formik.errors.phone}</div>}
                        <input
                            name="message"
                            placeholder="Message (optional)"
                            onChange={formik.handleChange}
                            value={formik.values.message}
                        />
                        {formik.touched.message && formik.errors.message && <div className="error">{formik.errors.message}</div>}
                        <button type="submit" className="submit-btn btnn">  {formik.isSubmitting ? <ClipLoader size={20} color="#fff" /> : 'Submit'}</button>
                    </div>
                </form>
            </div>
            <ToastContainer />
        </div>
    );
};

export default Form;
